import { ContractorsContextType, dispatchTypes, DispatchValue } from "./types";

export const ContractorsReducer = (state: ContractorsContextType, action: any) => {
    const { type, payload } = action
    switch (type) {
        case dispatchTypes.SET_VALUE: {
            const { attr, value } = payload as DispatchValue
            return {
                ...state as unknown as ContractorsContextType,
                [attr]: value
            }
        }
        case dispatchTypes.CLOSE_MODAL: {
            if (payload) {
                const { attr, value } = payload as DispatchValue
                return {
                    ...state as unknown as ContractorsContextType,
                    modalOpen: false,
                    [attr]: value
                }
            }
            return {
                ...state as unknown as ContractorsContextType,
                modalOpen: false,
            }

        }
        case dispatchTypes.OPEN_MODAL: {
            if (payload) {
                const { attr, value } = payload as DispatchValue
                return {
                    ...state as unknown as ContractorsContextType,
                    modalOpen: true,
                    [attr]: value
                }
            }
            return {
                ...state as unknown as ContractorsContextType,
                modalOpen: true,
            }
        }
        default:
            return state
    }
}